import { render, staticRenderFns } from "./MailServicePageAddModal.vue?vue&type=template&id=7a56f595"
import script from "./MailServicePageAddModal.vue?vue&type=script&lang=js"
export * from "./MailServicePageAddModal.vue?vue&type=script&lang=js"
import style0 from "./MailServicePageAddModal.vue?vue&type=style&index=0&id=7a56f595&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports